import { useEffect, useState } from "react";
import { waLink, WHATSAPP_INTENTS } from "../config";

export default function ExitPopup() {
  const [show, setShow] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    // Desktop only (mobile handled by sticky CTA bar)
    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    if (!isDesktop) return;

    let timer: ReturnType<typeof setTimeout>;

    const onMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 0 && !dismissed) {
        setShow(true);
      }
    };

    timer = setTimeout(() => {
      setShow(true);
    }, 25000);

    document.addEventListener("mouseleave", onMouseLeave);
    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseleave", onMouseLeave);
    };
  }, [dismissed]);

  if (!show) return null;

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center p-4 animate-fade-in">
      <div className="absolute inset-0 bg-foreground-950/50" onClick={() => setShow(false)}></div>
      <div className="relative bg-background-50 rounded-lg max-w-sm w-full p-6 md:p-7 text-center animate-fade-up">
        <button
          onClick={() => {
            setShow(false);
            setDismissed(true);
          }}
          className="absolute top-3 right-3 w-8 h-8 rounded-full bg-background-100 text-foreground-600 flex items-center justify-center hover:bg-background-200 transition-colors cursor-pointer"
          aria-label="Kapat"
        >
          <i className="ri-close-line"></i>
        </button>
        <div className="w-12 h-12 mx-auto rounded-full bg-accent-100 text-accent-900 flex items-center justify-center">
          <i className="ri-question-line text-2xl"></i>
        </div>
        <h3 className="mt-4 font-heading text-2xl font-bold text-foreground-950">
          KARAR VEREMEDİN Mİ?
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
          Bugünün menüsünü ve teslimat detaylarını WhatsApp'tan gönderebiliriz.
        </p>
        <a
          href={waLink(WHATSAPP_INTENTS.exit)}
          target="_blank"
          rel="nofollow noopener"
          className="mt-5 inline-flex items-center justify-center gap-2 w-full py-3.5 rounded-md bg-accent-500 text-background-50 dark:text-foreground-950 text-base font-bold hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-whatsapp-line text-xl"></i>
          WHATSAPP'TAN MENÜYÜ AL
        </a>
      </div>
    </div>
  );
}